var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30.6371,
    height: 30,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6617_628",
    transform: "matrix(0.00979206 0 0 0.01 0.0103971 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6617_628",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEXklEQVR4nO2dX2hOYRzHj+I8a4atGSN/RiJ/ttbackUUJYWLpSh/WiNtyi5mXmXJimmSi1FTsyJJU5aYxNQ5T4ziBmkXaMWNKH/S5Ib9dN4xNnuadc7z55zn+6lvrfdd7Tnnu6d93me/d3McAAAAAAAAAAAAAAAAAAAAYDTkOdnksTXpdDlTdK/Hash3DxBnfcQZ/UofcXe/7nVZCXms6q8ihsZjVbrXZxXUPXEacfZZWIjPvhDPnKF7ndZAvtsqLGOwFLdV9zqtgLwJxcTZ99ELYT/IG1+qe72Jh7jbNWoZf3bJfSJnnO41Jxbibvl/lzEYt1z3uhMJPXdc4uzFmAvx3V7ynAzd608cxN2DY98dg7vkoO7126W5fNQf8NBg5ZrLocFmaS6HBpunuRwabKDmMmiwUZrLocEGai6DBhuluRwabJ7mcmiwWZrLocHmaS6HBivT3JuNs+nGsTkj5tbxWdBg1Zq7a20ZbV+1fMRUry+FBqvW3Or1pcJCajaVQINVa27NphJhIXXlxdBg1ZpbV14sLOTQliJosGrNPbSlSFhIw7ZCaLBqzW3YVigspLFiKTRY9WluY8VSYSEndy8O8frE0qGIsKe5J3cvFhbSXL0ozItFO4ciwp7mNlcvEhbSUrMwxA6xcCgiitPclpqFwkLaaheEK8S2oYgoTnPbahcIC7mYmh9yh1g0GxzVae7F1HxhIe31BREUYslscFSnue31BcJCOo7MDV+IDbPBUQ4tdDTMFRYSnPhG9XUSq8FRDy10Ns4WFnL7xFiO3y3VYPLdVHTftYzuNM0SFuKdmhnhDkmXknKShIyhBe/UTGEh3c35EReSMA2WMbTQfTpfWMijlunRFpIkDZY1tPD47HRhIU/O5UkoJCEaLGto4em5PGEhPedzoy8kCRosZzaXpdNzIVdYyMtLOXIKibMGS5vN5QN5dSlHWMjr9mx5hcRVg6PWXBqWN1eyhYW87ZgscYfEUIOlz+Zylr7pokI+XM+SXEjMNFjFbO7X25np86yR8q0rU24hcdJgZbO5XHPiosFKZ3O57lIM12CZmkvGxlANlq25ZGpM1WDZmksjJLCp4Id4U+WSdK4cLqAPN7J0lJKyTnNpWHov59Cedf8OXAePBc+pLcQwDVbyFjQ+NPVbxZOLwXMadkmrtZr7sTNLWMbvfOqcaKcG69Dcd9cmjVrI+2uT7NNgXZrb7zHat0H8/pDgueBzrNJg3Zr74Ew+7Vj9bxnBYw/PRPwr3DhosA7NpWF52pZHR3cuo8q1Zen3HAYfP2ubqnVNWjRYh+ZSnKJag3VoLsUtqjSYPFZgxWkuD53vwb2SXwhnew24WIpFVPwN+uC/D2i/UB6T+G6tgkIyVmq/UB6T+Bkr5BdCzjjy3bvaL5YbnuAeqXrVTvecHOKsg3zWr/3CuWEZuCdXg3ukpIwhxXA2j3x3I/nuZsQN7sHG4J4oLwIAAAAAAAAAAAAAAAAAAMCJDz8Bcjnua3NTEykAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.c9a7f15b3496e70cc39c0102fb410821.svg";
export { ForwardRef as ReactComponent };